import { PDFDownloadLink } from "@react-pdf/renderer";
import PanelIzqStroLight from "../../nuevoStro/Light/PanelIzqStroLight";
import PDF from "../../pdf/Sicobe";
import MainStroCargasLight from "./MainStroCargasLight";
import { useNavigate } from "react-router-dom";
import { useCallback, useState } from "react";
import axios from "axios";
export default function NuevoStroCargasLight({ stro, carga4, reclamo, cargando, carga3, estados, estadosCodigos, frente, sicobe, carga2, pagosAnteriores, cobert, getLabelsFromValues, responsabilidadInput, responsabilidad, handleChange1, obs, setObs, stroRechazado, stroAmpliacion, stroCargado, docu, handleChangeFotos, handleChangeCedula, handleChangeCroquis, handleChangeRelato, handleChangeDanios, handleChangeRegistro, handleChangeDenunciaPol, setDocu, check, denunciaParaSicobe, planilla, setPlanilla, stroPosibleDuplicado }) {
    const navigate = useNavigate()
    const [nro, setNro] = useState(null)
    const buscarNro = useCallback(async (e) => {
        e.preventDefault();
        try {
            const response = await axios.get('https://back.agsseguros.online/api/buscarNroInput', { params: { nro } });
            const data = response.data;
            navigate(`/${data.id}`)
            window.location.reload()
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [nro]);
    return (
        <div className='contenedorStroLight'>
            <header className='headerStroDark'>
                {stro?.nroStro || stro?.entryId ? (
                    <div className='d-flex align-items-center gap-3 text-nowrap flex-shrink-0'>
                        <div className='nroStroHeaderNuevo'>{stro.nroStro ? `Siniestro: ${stro.nroStro.toString().substring(3)}` : `Denuncia ${stro.entryId}`}</div>
                        <div className='d-flex align-items-center gap-1'>
                            <span className='tipoStroNuevo'>Tipo:</span>{' '}
                            <span className="valorTipoStroNuevo" style={{ color: stro.tipoStro === 'ACCIDENTE DE TRANSITO' ? '#42C38B' : '#424FC3' }}>{stro.tipoStro}</span>
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
                <div style={{ position: 'relative', flexGrow: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'end', gap: '20px' }}>
                        <div className="center">
                            <input className="form-control form-control-sm w-75" type="number" placeholder="Buscar Stro" value={nro} onChange={(e) => setNro(e.target.value)}
                                onKeyDown={async (e) => {
                                    if (e.key === 'Enter') {
                                        buscarNro(e)
                                    }
                                }}></input>
                        </div>
                        <button className='botonCargaStroLight'>CARGA</button>
                        <a style={{ textDecoration: 'none' }} href="/#/" className="botonTablaStroLight">TABLA</a>
                    </div>
                </div>
            </header >
            {cargando ?
                <main className='mainStroLight'>
                    <PanelIzqStroLight stro={stro} carga4={carga4} reclamo={reclamo} estados={estados} estadosCodigos={estadosCodigos} carga3={carga3} planilla={planilla} setPlanilla={setPlanilla} />
                    <MainStroCargasLight stro={stro} carga3={carga3} estados={estados} estadosCodigos={estadosCodigos} frente={frente} sicobe={sicobe} carga2={carga2} pagosAnteriores={pagosAnteriores} cobert={cobert} getLabelsFromValues={getLabelsFromValues} responsabilidadInput={responsabilidadInput} responsabilidad={responsabilidad} handleChange1={handleChange1} obs={obs} setObs={setObs} cargando={cargando} stroRechazado={stroRechazado} stroPosibleDuplicado={stroPosibleDuplicado} stroAmpliacion={stroAmpliacion} stroCargado={stroCargado} docu={docu} handleChangeFotos={handleChangeFotos} handleChangeCedula={handleChangeCedula} handleChangeCroquis={handleChangeCroquis} handleChangeRelato={handleChangeRelato} handleChangeDanios={handleChangeDanios} handleChangeRegistro={handleChangeRegistro} handleChangeDenunciaPol={handleChangeDenunciaPol} setDocu={setDocu} check={check} />
                </main>
                : <div className="center pt-5"><div class="spinner-border text-success center" role="status"></div></div>}
            {carga2 ? <PDFDownloadLink document={<PDF sicobe={sicobe} pagosAnteriores={pagosAnteriores} cobert={cobert} denunciaParaSicobe={denunciaParaSicobe} />} fileName={`sicobeStro${denunciaParaSicobe}.pdf`}>
                {({ loading, url, error, blob }) => <div className='d-none'><button id="botonSicobe">Descargar Sicobe</button></div>}
            </PDFDownloadLink> : null}
        </div>
    );
}